import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var productCareDoNotWashIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "m22.789 3 .464.11c.48.114.794.586.742 1.086l-.019.115-1.37 6.284a1.002 1.002 0 0 1 1.201.577l.192.46-1.782.743-1.254 5.746 2.097.875c.475.199.717.72.578 1.201l-.039.11-.192.46-2.77-1.157-.533 2.45a.476.476 0 0 1-.383.367l-.082.007H4.492a.755.755 0 0 1-.71-.496l-.029-.102-.342-1.607-2.819 1.177-.193-.462a1 1 0 0 1 .537-1.307l2.157-.9-1.507-7.084L0 10.991l.191-.458a1.005 1.005 0 0 1 1.027-.611L.023 4.312c-.107-.501.167-.998.62-1.163l.108-.032.466-.108.506 2.38c.31 1.144 1.528 1.976 2.903 1.976 1.646 0 2.69-1.17 3.218-1.988a.467.467 0 0 1 .797.013c.493.817 1.517 1.975 3.359 1.975 1.839 0 2.862-1.153 3.356-1.97a.465.465 0 0 1 .802-.015c.529.817 1.572 1.985 3.216 1.985 1.307 0 2.471-.753 2.844-1.813l.048-.153L22.789 3ZM12.766 16.322l-8.004 3.343.27 1.27h13.844l.412-1.889-6.522-2.724ZM3.2 12.328l1.244 5.844 6.376-2.662-7.62-3.182Zm17.396.724L14.71 15.51l4.902 2.047.983-4.505Zm-4.877-5.618c-.763.898-2.075 1.431-3.719 1.431-1.645 0-2.956-.533-3.72-1.43-.735.904-2.015 1.43-3.654 1.43a4.692 4.692 0 0 1-2.062-.477l-.228-.119.484 2.275 9.946 4.153 8.22-3.433.65-2.978a4.704 4.704 0 0 1-2.262.58c-1.639 0-2.919-.527-3.655-1.432Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { productCareDoNotWashIcon as default };
//# sourceMappingURL=productCareDoNotWashIcon.js.map
